import NavigationIcon from '@mui/icons-material/Navigation';
import {
	Autocomplete,
	Box,
	Dialog,
	DialogContent,
	DialogTitle,
	Grid,
	TextField,
	Typography
} from '@mui/material';
import { NAVIGATION_ACCESSIBLE_ROUTES } from 'constants/routes';
import { useNavigate } from 'hooks';
import React, { FC } from 'react';

const OPEN_DIALOG_KEY = 'k';

const NavigationDialog: FC = () => {
	const navigate = useNavigate();
	const [open, setOpen] = React.useState(false);

	const handleClose = React.useCallback(() => {
		setOpen(false);
	}, [setOpen]);

	const downHandler = React.useCallback((event: KeyboardEvent) => {
		if (event.key === OPEN_DIALOG_KEY && (event.metaKey || event.ctrlKey)) {
			event.preventDefault();
			event.stopPropagation();
			setOpen(true);
		}
	}, []);

	React.useEffect(() => {
		window.addEventListener('keydown', downHandler);

		return () => {
			window.removeEventListener('keydown', downHandler);
		};
	}, [downHandler]);

	return (
		<Dialog open={open} disableRestoreFocus onClose={handleClose}>
			<DialogTitle>
				<Box display="flex" flexDirection="row" alignItems="center">
					<NavigationIcon />
					<Typography
						variant="h6"
						pl={1}
						title={intl.tr('pages.navigation.header')}
					>
						{intl.tr('pages.navigation.header')}
					</Typography>
				</Box>
			</DialogTitle>
			<DialogContent>
				<Grid container spacing={3} p={1}>
					<Grid item xs={12}>
						<Autocomplete
							id="navigation-autocomplete"
							data-testid="navigation-autocomplete"
							options={NAVIGATION_ACCESSIBLE_ROUTES}
							getOptionLabel={(option) =>
								option.labelId ? intl.tr(option.labelId) : ''
							}
							onChange={(_, route) => {
								handleClose();
								if (route) {
									navigate(route.path);
								}
							}}
							renderInput={(params) => (
								<TextField
									{...params}
									label={intl.tr('pages.navigation.title')}
									placeholder={intl.tr('pages.navigation.placeholder')}
									autoFocus
								/>
							)}
						/>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	);
};

export default NavigationDialog;
